export default "__VITE_ASSET__d59883f7__"